export const SET_LOADING = "BUSSINESS_STEP/SET_LOADING";
export const SET_WIDGETS = "BUSSINESS_STEP/SET_WIDGETS";
